import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

/**
 * @description Single-line note field that wraps and grows to fit its text.
 *              Enter is ignored and pasted line breaks become spaces.
 */
@Directive({
  selector: 'textarea[appNoteInput]',
})
export class NoteInputDirective implements AfterViewInit, OnDestroy {
  private valueChanges?: Subscription;

  constructor(
    private el: ElementRef<HTMLTextAreaElement>,
    @Optional() @Self() private ngControl?: NgControl
  ) {}

  ngAfterViewInit(): void {
    this.valueChanges = this.ngControl?.valueChanges?.subscribe(() => this.resize());
    this.resize();
  }

  @HostListener('keydown.enter', ['$event'])
  preventLineBreak(event: Event): void {
    event.preventDefault();
  }

  @HostListener('input')
  removeLineBreaks(): void {
    const textarea = this.el.nativeElement;
    if (!/[\r\n]/.test(textarea.value)) return;
    const caret = textarea.selectionStart;
    const value = textarea.value.replace(/\r\n?|\n/g, ' ');
    textarea.value = value;
    textarea.setSelectionRange(caret, caret);
    this.ngControl?.control?.setValue(value);
  }

  @HostListener('focus')
  resize(): void {
    const textarea = this.el.nativeElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  ngOnDestroy(): void {
    this.valueChanges?.unsubscribe();
  }
}
